import { type FilteredModelsQueryParameters } from './useQueryFilteredModels';
import { type FilteredProjectsQueryParameters } from './useQueryFilteredProjects';

/**
 * Query key factory for AI-related queries.
 */
export const queryKeysAi = {
  base: () => 'ai' as const,
  getDocumentsPerProject: (projectName: string) =>
    [queryKeysAi.base(), 'projects', 'documents', { projectName }] as const,
  getDownloadAiFile: (blobInfoEncoded: string) =>
    [queryKeysAi.base(), 'file', { blobInfoEncoded }] as const,
  getFilteredModels: (queryParameters: FilteredModelsQueryParameters) =>
    [queryKeysAi.base(), 'models', 'list', queryParameters] as const,
  getFilteredProjects: (queryParameters: FilteredProjectsQueryParameters) =>
    [queryKeysAi.base(), 'projects', 'list', queryParameters] as const,
  getMappingsFields: () => [queryKeysAi.base(), 'mappings', 'fields'] as const,
  getProjectByModel: (modelId: string) =>
    [queryKeysAi.base(), 'projects', 'byModel', { modelId }] as const,
} as const;
